import { Container, Row, Col } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import './AirExportLogisticsSoftware.css';
import Phone from '../img/Contact Icons/call.png';
import Mail from '../img/Contact Icons/mail.png';
import Map from '../img/Contact Icons/map.png';
import Whatsapp from '../img/Contact Icons/whatsapp.png';
import './About.css';
import './Contact.css';


function ContactForm() {
  return (
    <Container id="contact" className="py-5 space-container">
      <div className='my-3'>
        <h2 className='text-center fade-in'>Catus L.M.S Making Your Logistics Business Easier</h2>
        <hr />
        <Row className="g-4 my-2">
          <Col xs={12} md={6} className='my-3 py-2'>
            <h2 className='py-2'><u>Get in Touch</u></h2>
            {/* <p className='fs-5 py-4'>Please contact us via the below form. </p> */}
            <p className="fs-4 fs-md-4 py-3 text-justify"><strong>Ready to streamline your freight forwarding operations? Our team is here to help!
              Reach out for a demo, support, or to discuss how our software can optimize your logistics.</strong></p>
            <p className="fs-4 fs-md-5 py-3" style={{ textIndent: "-3rem" }}>
              <img className='mx-2' src={Phone} alt="Phone Logo" width={30} height={30} />
              Mobile No.
              <a href="tel:+919899712724" className="contact-link mx-2">
                +91-9899-712-724
              </a></p>
            <p className="fs-4 fs-md-5 py-3" style={{ textIndent: "-3rem" }}>
              <img className='mx-2' src={Whatsapp} alt="Phone Logo" width={30} height={30} />
              WhatsApp.
              <a
                href="https://wa.me/9899712724?"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Chat with us on WhatsApp"
                className="contact-link mx-2"
              >
                +91-9899-712-724
              </a>
            </p>

            <p className="fs-4 fs-md-5 py-3" style={{ textIndent: "-3rem" }}>
              <img className='mx-2' src={Mail} alt="Phone Logo" width={30} height={30} />
              Email-
              <a href="mailto:info@catustechnologies.com" className="contact-link mx-2">
                info@catustechnologies.com
              </a></p>

            <p className="fs-4 fs-md-5 py-3 text-justify" style={{ textIndent: "-3rem" }}>
              <img className='mx-2' src={Map} alt="Phone Logo" width={30} height={30} />
              Address - 1705-B, 17th Floor, The Iconic Corenthum, Opp Electronic City Metro Station, Sector 62, Noida Uttar Pradesh - 201309
            </p>

          </Col>

          <Col xs={12} md={6} className="my-3 py-2">
            <Card
              className="my-2 p-2 animated-card"
              border="primary"
              style={{
                border: "3px solid #0d6efd",
                width: "100%",
                maxWidth: "1000px", // ✅ increased width
                aspectRatio: "1 / 1",
                borderRadius: "8px",
                overflow: "hidden"
              }}
            >
              <Card.Body style={{ padding: 0 }}>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.071887207812!2d77.3735572!3d28.6276075!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce5574455d57b%3A0xf19bca2bae503f87!2sIconic%20Tower!5e0!3m2!1sen!2sin!4v1761329685964!5m2!1sen!2sin"
                  style={{
                    width: "100%",
                    height: "100%",
                    border: 0
                  }}
                  allowFullScreen=""
                  loading="lazy"
                  title="Map"
                />
              </Card.Body>
            </Card>
          </Col>
          
        </Row>
      </div>
    </Container>
  );
}

export default ContactForm;